var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2fbf68a46a4ee6ea43dfcf9e2b03e08478440f35"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["magal@magal-jewelry"]={id:"2fbf68a46a4ee6ea43dfcf9e2b03e08478440f35"};
      